import { Controller } from "@hotwired/stimulus"

export class CurrencyController extends Controller {
  static targets = ["input", "submit"]

  update(event) {
    const currency_options = {  }
    const money = new Intl.NumberFormat('en-US', currency_options)
    const raw = event.target.value
    const snipped = raw.replace(/,/g, "")
    const last_char = raw.charAt(raw.length-1)
    const formatted = money.format(parseInt(snipped))

    if (isNaN(parseInt(snipped))) {
      this.submitTarget.disabled = true
      this.submitTarget.classList.add("btn-error")
      this.submitTarget.classList.remove("btn-success")
      event.target.classList.remove("bg-success/30")
      event.target.classList.add("bg-error/30")
    } else {
      let result = formatted
      if (last_char === ",") {
        result = formatted + last_char
      }
      this.submitTarget.disabled = false
      this.submitTarget.classList.remove("btn-error")
      this.submitTarget.classList.add("btn-success")
      event.target.classList.add("bg-success/30")
      event.target.classList.remove("bg-error/30")
      event.target.value = result
    }
  }
}

export class CopyController extends Controller {
  static targets = ["input", "button"]

  toClipboard() {
    const element = this.inputTarget
    const url = element.value

    window.navigator.clipboard.writeText(url)

    const buttonAlert = () => {
      this.buttonTarget.classList.remove("secondary-button")
      this.buttonTarget.classList.add("copy-success-button")
      this.buttonTarget.textContent = "Copied!"
    }

    const buttonAlertRevert = () => {
      this.buttonTarget.classList.remove("copy-success-button")
      this.buttonTarget.classList.add("secondary-button")
      this.buttonTarget.textContent = "Share"
    }

    if (url) {
      buttonAlert()
      setTimeout(buttonAlertRevert, 3000)
    }
  }
}

export class HamburgerController extends Controller {
  static targets = ["menu", "toggle"]
  static values = {toggled: Boolean}

  connect() {
    const handler = (e) => {
      if (this.toggledValue && !this.menuTarget.contains(e.target) && !this.toggleTarget.contains(e.target)) {
        this.toggledValue = false
      }
    }

    document.addEventListener('click', handler)
  }

  toggle() {
    this.toggledValue = !this.toggledValue
  }

  toggledValueChanged(toggled) {
    if (toggled) {
      this.menuTarget.classList.remove("hidden")
    } else {
      this.menuTarget.classList.add("hidden")
    }
  }
}








